import React from 'react';
import Constant from '@/common/constant/Constant';
import Utils from '@/common/utils/utils';
import { filterSugguestionAssignOption, getAssignList, getAssignTicketData, onClickChangeTicketAssign, onSelectNewAssign, getCurrentStatusData } from './handler/TicketListHandler';
import { Button, Paper, Popover, TextField, Tooltip } from '@material-ui/core';
import { Autocomplete } from '@material-ui/lab';
import { I18n } from 'aws-amplify';

export default function DetailTicketListAssignee(props) {
    const {
        ticket,
        isCustomerListTicket,
        isHelpdeskListTicket,
        userDetail,
        selectedTicket,
        isDeletedCorporationOrigin,
        idAssignListPopover,
        isOpenAssignListPopover,
        openAssignListPopoverId,
        assignListPopover,
        setAssignListPopover,
        setOpenAssignListPopoverId,
        projectUserList,
        corporationDetail,
        projectInuseDetail
    } = {...props};

    // assignData
    const currentStatusData = getCurrentStatusData(ticket);
    const currentStatusItemData = currentStatusData?.currentStatusItemData;
    const currentStatusItemStructure = Utils.convertJSONDataToObject(
        currentStatusItemData?.structure
    );
    let assignData = getAssignTicketData(ticket, props);
    
    let {
        hasAssignee,
        assigneeAvatar,
        assigneeIcon,
        assigneeFullName,
        canHasAssignee,
    } = assignData;

    const PopperAssign = popperProps => {
        const { className, anchorEl, style, ...rest } = popperProps;
        const bound = anchorEl.getBoundingClientRect();
        return (
            <div
                {...rest}
                style={{
                    position: 'absolute',
                    zIndex: 9999,
                    width: bound.width
                }}
            />
        );
    };

    const isDisableChangeAssignee = () => {
        if ([Constant.TICKET_TYPE.TASK, Constant.TICKET_TYPE.EMAIL].includes(ticket.ticketType)) {
            if (
                ticket?.ticketType === Constant.TICKET_TYPE.EMAIL &&
                ((currentStatusItemStructure.no === Constant.STATUS_NO.DONE &&
                    !Utils.isPublicDesk(projectInuseDetail)) ||
                    (!Utils.isEnableCreateEmailTicketMode(
                        props?.corporationDetail,
                        props?.projectInuseDetail
                    ) &&
                        currentStatusItemStructure?.no === Constant.STATUS_NO.DONE))
            )
                return true;

            return false;
        }    

        if (Utils.isAnonymousQAEndLiveChatTicket(ticket)) {
            return true;
        }

        if(Utils.isDisabledTicketExternalWhenDeskServiceOff(ticket, corporationDetail)) {
            return true;
        }
        
        return false;
    }

    const getCursorClassForAssignee = () => {
        if (Utils.isDisableEditEmailTicket(ticket, props?.projectInuseDetail, props?.corporationDetail, currentStatusItemStructure?.no)) {
            return 'context-menu';
        }

        if (
            Utils.isEmptyString(ticket.deletedAt) &&
            !isDeletedCorporationOrigin
        ) {
            return 'pointer';
        }

        return 'context-menu';
    }; 

    const renderAssignList = () => {
        let assignList = [];
        if (!Utils.isEmptyObject(selectedTicket)) {
            assignList = getAssignList(projectUserList, userDetail);
        }
        return (
            <div className="assign-list-all">
                <Paper className="assign-list-filter-group">
                    <Button className="btn-icon-search" variant="contained" color="primary">
                        <img src="/assets/image/icon-searchFrame.svg" alt="" />
                    </Button>
                    <Autocomplete
                        PopperComponent={PopperAssign}
                        className="assign-filter-text"
                        // freeSolo
                        disableClearable
                        sx={{
                            maxHeight: 3
                        }}
                        options={assignList || []}
                        getOptionLabel={option => {
                            return option.fullName || '';
                        }}
                        getOptionSelected={(option, selectedValue) => {
                            return option.fullName === Constant.OPTION_ASSIGNEE_ME
                                ? false
                                : option.id === selectedValue;
                        }}
                        value={selectedTicket.personInChargeInfo?.id || Constant.OPTION_UNASSIGNEE.KEY}
                        filterOptions={filterSugguestionAssignOption}
                        renderOption={option => (
                            <Tooltip
                                title={option.fullName}
                                className={
                                    option.id === ticket.personInChargeInfo?.id
                                        ? 'assign-filter-tooltip active'
                                        : 'assign-filter-tooltip'
                                }
                            >
                                { option.fullName !== Constant.OPTION_UNASSIGNEE.TEXT ?
                                <span className="assign-option">
                                    {option.avatar && (
                                        <img
                                            src={option.avatar}
                                            alt=""
                                            className="assign-filter-avatar assign-filter-img"
                                        />
                                    )}
                                    {!option.avatar && (
                                        <span className="assign-filter-icon assign-filter-img">
                                            {Utils.getShortName(
                                                Utils.getTextByLanguage(
                                                    Constant.LANGUAGE_TYPE.JP,
                                                    option.lastName
                                                )
                                            )}
                                        </span>
                                    )}
                                    <span className="assign-filter-name">{option.fullName}</span>
                                    </span> 
                                    : 
                                    <span className="assign-option">
                                        <span className="">{option.fullName}</span>
                                    </span> 
                                }
                            </Tooltip>
                        )}
                        open={Utils.isEmptyArray(assignList) ? false : true}
                        onChange={(e, newValue) => {
                            onSelectNewAssign(newValue, props);
                        }}
                        // noOptionsText={I18n.get('COMMSG001')}
                        renderInput={params => (
                            <TextField
                                {...params}
                                className="form-control-wrapInput form-control-hg32 assign-input"
                                placeholder="検索キーワード"
                                variant="outlined"
                            />
                        )}
                    />
                </Paper>
                {Utils.isEmptyArray(assignList) && <p>{I18n.get('COMMSG001')}</p>}
            </div>
        );
    };

    return (
        <>
            {/* QA side */}

            {isCustomerListTicket &&
                canHasAssignee &&
                hasAssignee &&
                assigneeAvatar &&
                ticket.personInChargeInfo &&
                ticket.personInChargeInfo.picFieldPrivateStatus >= 2 && (
                    <Tooltip title={assigneeFullName}>
                        <img
                            src={assigneeAvatar}
                            alt=""
                            className="chat-avatar-frame assignee-avatar assignee-avatar-qa-side"
                        />
                    </Tooltip>
                )}

            {isCustomerListTicket &&
                canHasAssignee &&
                hasAssignee &&
                !assigneeAvatar &&
                assigneeIcon &&
                ticket.personInChargeInfo &&
                ticket.personInChargeInfo.picFieldPrivateStatus >= 2 && (
                    <Tooltip title={assigneeFullName}>
                        <div className="assignee-icon assignee-icon-qa-side">{assigneeIcon}</div>
                    </Tooltip>
                )}

            {isHelpdeskListTicket && canHasAssignee && (
                <div>
                    {!hasAssignee && (
                        <Tooltip
                            title={'担当者を割り当て'}
                            style={{
                                cursor: getCursorClassForAssignee()
                            }}
                        >
                            <div
                                style={{
                                    cursor: getCursorClassForAssignee()
                                }}
                                aria-describedby={idAssignListPopover}
                                id={idAssignListPopover}
                                className={
                                    isDisableChangeAssignee(ticket)
                                        ? 'text-assign-please disable-change-assign'
                                        : 'text-assign-please'
                                }
                                key={`select-assign-${ticket.id}`}
                                onClick={event => {
                                    onClickChangeTicketAssign(
                                        event,
                                        ticket,
                                        props,
                                        isDeletedCorporationOrigin
                                    );
                                }}
                            >
                                <img
                                    src="/assets/image/user-circle.svg"
                                    alt=""
                                    className="chat-avatar-frame assignee-avatar"
                                    style={{
                                        cursor: getCursorClassForAssignee()
                                    }}
                                />
                            </div>
                        </Tooltip>
                    )}
                    {hasAssignee && assigneeAvatar && (
                        <Tooltip
                            title={assigneeFullName}
                            style={{
                                cursor: getCursorClassForAssignee()
                            }}
                        >
                            <img
                                aria-describedby={idAssignListPopover}
                                id={idAssignListPopover}
                                src={assigneeAvatar}
                                key={`select-assign-${ticket.id}`}
                                alt=""
                                className="chat-avatar-frame assignee-avatar"
                                onClick={event => {
                                    onClickChangeTicketAssign(
                                        event,
                                        ticket,
                                        props,
                                        isDeletedCorporationOrigin
                                    );
                                }}
                            />
                        </Tooltip>
                    )}
                    {hasAssignee && !assigneeAvatar && assigneeIcon && (
                        <Tooltip
                            title={assigneeFullName}
                            style={{
                                cursor: getCursorClassForAssignee()
                            }}
                        >
                            <div
                                aria-describedby={idAssignListPopover}
                                id={idAssignListPopover}
                                className="assignee-icon"
                                key={`select-assign-${ticket.id}`}
                                onClick={event => {
                                    if (isDisableChangeAssignee()) return;

                                    onClickChangeTicketAssign(
                                        event,
                                        ticket,
                                        props,
                                        isDeletedCorporationOrigin
                                    );
                                }}
                            >
                                {assigneeIcon}
                            </div>
                        </Tooltip>
                    )}
                    <Popover
                        id={idAssignListPopover}
                        key={`select-assign-content-${ticket.id}`}
                        className="select-assign-content-wrap"
                        open={isOpenAssignListPopover && openAssignListPopoverId === ticket.id}
                        anchorEl={assignListPopover}
                        onClose={e => {
                            setAssignListPopover(null);
                            setOpenAssignListPopoverId(null);
                        }}
                        anchorOrigin={{
                            vertical: 'bottom',
                            horizontal: 'left'
                        }}
                    >
                        <div className="assignee-list">{renderAssignList()}</div>
                    </Popover>
                </div>
            )}
        </>
    );
}
